import { RootState } from '../../rootState';
import { createSelector } from 'reselect';

export const selectLanguageState = (root: RootState) => root.language;

export const selectCurrentLanguage = createSelector(selectLanguageState, state => state.language);



// WEBPACK FOOTER //
// ./src/modules/language/selectors.tsx